import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MuiMenuItem from '@material-ui/core/MenuItem';
import withWidth from '@material-ui/core/withWidth';

const styles = theme => ({
  root: {
    display: 'block',
    minWidth: 148,
    textAlign: 'center',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    '&:first-child': {
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      borderTop: 'none',
    },
    '&:last-child': {
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'none',
    },
  },
  colorWarning: {
    color: theme.palette.validation[500],
  },
});

const MenuItem = ({
  className, classes, style, children, onClick, color, width, ...otherProps
}) => (
  <MuiMenuItem
    className={classNames(className, {
      [classes.colorWarning]: color === 'warning',
    })}
    classes={{
      root: classes.root,
    }}
    onClick={(event) => {
      if (['xs', 'sm'].indexOf(width) !== -1) {
        event.stopPropagation();
      }
      onClick();
    }}
    style={style}
    {...otherProps}
  >
    {children}
  </MuiMenuItem>
);

MenuItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  color: PropTypes.oneOf(['default', 'warning']),
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    colorWarning: PropTypes.string.isRequired,
  }).isRequired,
};

MenuItem.defaultProps = {
  onClick: () => {},
  color: 'default',
  className: '',
  style: {},
};

export default withWidth()(withStyles(styles)(MenuItem));



// WEBPACK FOOTER //
// ./src/components/common/Menu/MenuItem.js